var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"Container"},[_c('h2',{staticClass:"ViewHeading"},[_vm._v("Device List")]),(_vm.profileportal === 'CEU')?_c('div',[_c('DeviceCEU')],1):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }